// extracted by mini-css-extract-plugin
export default {"links":"AboutLinks_links__aMBYm","link":"AboutLinks_link__lBVEB","container":"AboutLinks_container__OFHRt"};